import React, { useContext } from "react";
import { ColorSelector } from "../../components/ColorSelector";
import { StoreContext } from "../../store/Store";
import { actionTypes } from "../../store/storeTypes";

const colours = [
  { filter: "taskBorderColor", display: "border" },
  { filter: "taskFontColor", display: "text" },
  { filter: "taskBackgroundColor", display: "background" },
];

const marginTop = 5;

export const TaskFilterPanel = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { flowConfig } = store;

  const changefilter = (val, key) => {
    const newFilter = { ...flowConfig, [key]: val };
    dispatch({ type: actionTypes.SET_FLOWCONFIG, payload: newFilter });
    dispatch({ type: actionTypes.SET_NEWFLOWLAYOUTTRIGGER, payload: true });
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        marginTop: 10,
        display: "block",
      }}
    >
      <div>
        {/* taskFontSize */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={5}
            max={60}
            value={flowConfig.taskFontSize}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "taskFontSize")
            }
          />
          {`font size ${flowConfig.taskFontSize}`}
        </div>
        {/* taskFontWeight */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={100}
            max={900}
            step={100}
            value={flowConfig.taskFontWeight}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "taskFontWeight")
            }
          />
          {`font Weight ${flowConfig.taskFontWeight}`}
        </div>
        {/* taskBorderWidth */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={20}
            value={flowConfig.taskBorderWidth}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "taskBorderWidth")
            }
          />
          {`border width ${flowConfig.taskBorderWidth}`}
        </div>
        {/* taskBorderRadius */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={30}
            value={flowConfig.taskBorderRadius}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "taskBorderRadius")
            }
          />
          {`border radius ${flowConfig.taskBorderRadius}`}
        </div>
        {/* taskLineHeight */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            // step={0.1}
            min={10}
            max={30}
            value={flowConfig.taskLineHeight}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "taskLineHeight")
            }
          />
          {`Line Height ${flowConfig.taskLineHeight / 10}`}
        </div>
        {/* taskPaddingH */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.taskPaddingH}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "taskPaddingH")
            }
          />
          {`H Padding ${flowConfig.taskPaddingH}`}
        </div>
        {/* taskPaddingV */}
        <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={0}
            max={60}
            value={flowConfig.taskPaddingV}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "taskPaddingV")
            }
          />
          {`V Padding ${flowConfig.taskPaddingV}`}
        </div>
         {/* taskWidth */}
         <div style={{ marginTop: marginTop }}>
          <input
            style={{ width: 200 }}
            type="range"
            min={60}
            max={600}
            value={flowConfig.taskWidth}
            onChange={(e) =>
              changefilter(e.target.valueAsNumber, "taskWidth")
            }
          />
          {`Width ${flowConfig.taskWidth}`}
        </div>
      </div>
      <ColorSelector
        colours={colours}
        changefilter={changefilter}
        filter={flowConfig}
      />
    </div>
  );
};
